import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface ISidebarItem {
  text?: string;
  Icon: React.ElementType;
  active?: boolean;
  href?: string;
}

function SidebarItemIcon({ text, Icon, active, href }: ISidebarItem) {
  const navigate = useNavigate();

  return (
    <Tooltip title={text} placement="right" arrow>
      <IconButton
        onClick={() => navigate(href as string)}
        sx={
          active
            ? {
                borderRadius: "10px",
                width: "40px",
                height: "40px",
                color: "common.white",
                backgroundColor: "primary.main",
                "&:hover": {
                  color: "common.white",
                  backgroundColor: "primary.main",
                },
              }
            : {
                borderRadius: "10px",
                width: "40px",
                height: "40px",
                color: "text.primary",
                "&:hover": {
                  color: "primary.main",
                  backgroundColor: "primary.600",
                },
              }
        }
      >
        <Icon size="20px" />
      </IconButton>
    </Tooltip>
  );
}

export default SidebarItemIcon;
